export default __webpack_public_path__ + "static/media/milestone 1700.38a34ad9.svg";